import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { RecallsQueryKeys } from "components/Recalls/queryKeys";
import { useTypedQuery } from "hooks";
import { FIXED_VIN_LENGTH } from "modules/Appointments/components/NewAppointment/utils";
import { ApiInstance } from "utils/Api";

type RecallsListParams = {
  isModalOpen: boolean;
  vin?: string;
  appointmentId?: number;
  license_plate?: string;
  dealer_location_id?: number;
};

export const useRecallsQuery = ({ isModalOpen, appointmentId, vin, license_plate, dealer_location_id }: RecallsListParams) => {
  const { selectedLocation } = useSelectedLocation();

  const trimmedVin = vin?.trim();
  const validVin = trimmedVin?.length === FIXED_VIN_LENGTH ? trimmedVin : undefined;
  const waitsForModal = Boolean(appointmentId) && !isModalOpen;

  const { data, isLoading } = useTypedQuery({
    queryKey: RecallsQueryKeys.list({ vin: validVin, license_plate, dealer_location_id }),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    enabled: Boolean(selectedLocation?.id) && Boolean(validVin ?? license_plate) && !waitsForModal
  });

  return {
    loading: isLoading,
    data: {
      distrimateRecalls: data?.recalls ?? [],
      rdwRecalls: data?.rdw_recalls ?? [],
      ponRecalls: data?.pon_recalls ?? [],
      hasConvertableRecalls: data?.has_convertable_recalls ?? false
    }
  };
};
